module.exports = __webpack_public_path__ + "img/wearchemists_card_image.98844842.jpg";